import { LinkedItem, SceneObjects } from '@types'

export default function isLinkedItem(linkedItem?: SceneObjects): linkedItem is LinkedItem {
  return Boolean(linkedItem) && linkedItem?.type === 'linkedItem'
}
